// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e482e883","845":"0d5801ef"}[chunkId] + ".chunk.js";
};